export const createEmptyRowSelectionModel = () => ({
	type: "include",
	ids: new Set(),
});

export const getSelectedIdsFromModel = (selectionModel, sourceRows = []) => {
	if (!selectionModel || !selectionModel.ids) {
		return [];
	}

	if (selectionModel.type === "exclude") {
		return sourceRows
			.map((row) => row.classid)
			.filter((classid) => !selectionModel.ids.has(classid));
	}

	return Array.from(selectionModel.ids);
};
